import { COUNTRY_COOKIE_KEY } from '@/utils/constants'
export default defineNuxtRouteMiddleware(async (to) => {
  try {
    const currentLocale = useLocale()
    const countriesApi = useCountries()
    const { $mRouter } = useNuxtApp()
    const countryCookie = useCookie(COUNTRY_COOKIE_KEY)
    if (!countryCookie.value) {
      return
    }
    if (countryCookie.value && to.meta.key === 'majority-account-home') {
      const country = await countriesApi.getCountry(countryCookie.value)
      const route = $mRouter.getLocalRoute({ name: 'country-majority-account', params: { country: country.slug } })
      return navigateTo(route)
    }
    if (countryCookie.value && to.meta.key === 'majority-pay-home') {
      const country = await countriesApi.getCountry(countryCookie.value)
      const route = $mRouter.getLocalRoute({ name: 'country-majority-pay', params: { country: country.slug } })
      return navigateTo(route)
    }
    if (countryCookie.value && to.meta.key === 'visa-debit-card-home') {
      const country = await countriesApi.getCountry(countryCookie.value)
      const route = $mRouter.getLocalRoute({ name: 'country-visa-debit-card', params: { country: country.slug } })
      return navigateTo(route)
    }
    if (countryCookie.value && to.meta.key === 'money-transfers-home') {
      const country = await countriesApi.getCountry(countryCookie.value)
      const route = $mRouter.getLocalRoute({ name: 'country-money-transfers', params: { country: country.slug } })
      return navigateTo(route)
    }

    if (countryCookie.value && to.meta.key === 'international-calling-home') {
      const country = await countriesApi.getCountry(countryCookie.value)
      const route = $mRouter.getLocalRoute({ name: 'country-international-calling', params: { country: country.slug } })
      return navigateTo(route)
    }

    if (countryCookie.value && to.meta.key === 'mtu-home') {
      const countryMtuSlugs = {
        CU: {
          en: 'recargas',
          es: 'recargas'
        },
        NG: {
          en: 'airtime',
          es: 'recargas'
        },
        MX: {
          en: 'recargas',
          es: 'recargas'
        },
        GH: {
          en: 'airtime',
          es: 'recargas'
        },
        KE: {
          en: 'airtime',
          es: 'recargas'
        },
        ET: {
          en: 'airtime',
          es: 'recargas'
        },
        CM: {
          en: 'airtime',
          es: 'recargas'
        }
      }
      const otherSlugs = {
        en: 'mobile-top-ups',
        es: 'recargas-moviles'
      }
      const country = await countriesApi.getCountry(countryCookie.value)
      const mtuSlug = countryMtuSlugs[country.id] ? countryMtuSlugs[country.id][currentLocale] : otherSlugs[currentLocale]
      const route = $mRouter.getLocalRoute({ name: 'country-mtu', params: { country: country.slug, mtu: mtuSlug } })
      return navigateTo(route)
    }
  } catch (error) {
    console.error('ERROR: ', error)
  }
})
